const Request = {
  DBInfo: "/Tables/Intent/Info",
  List: "/Tables/Intent/List",
  Add: "/Tables/Intent/Add",
  Delete: "/Tables/Intent/Delete",
  Edit: "/Tables/Intent/Edit",
  Export: "/Tables/Intent/Export",
  Import: "/Tables/Intent/Import",
  Sync: "/Tables/Intent/Sync",
  DeleteBulk: "/Tables/Intent/DeleteBulk"
};

let exports = {
  Request
};

export default exports;